<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <b-button variant="secondary" class="ml-2" @click="$router.go(-1);">
        <i class="fas fa-arrow-left"></i> {{ $t('volver') }}
      </b-button>
      <b-card-header class="border-0">
        <div>
          <h3 v-if="ingreso && estadoIngresoOptions.length" class="d-flex justify-content-center w-100 mb-0">
            <b-badge class="badge-lg"
              :variant="['info', 'warning', 'success'][ingreso && estadoIngresoOptions.length ? [7, 10, 13].includes(ingreso.estadoID) ? 0 : [1, 2, 3, 4, 5, 14, 15].includes(ingreso.estadoID) ? 1 : 2 : 2]">

              <strong>
                {{ingreso && ingreso.estadoID > 0 && estadoIngresoOptions.length ? estadoIngresoOptions.find(t =>
                  t.value ===
                  ingreso.estadoID).text : 'Sin Estado configurado'}} </strong>
            </b-badge>
          </h3>
        </div>
      </b-card-header>

      <div class="d-flex">
        <h3 class="mb-0">{{ $t('ingreso') }} #{{ ingreso.id }} </h3>
      </div>

      <Loading v-if="loading" />

      <b-form v-else @submit.prevent="submitForm">
        <div class="d-flex justify-content-end mb-5">
          <b-button v-if="(ingreso.isActaValid && ingreso.numeroActa > 0)" style="background-color: yellow;"
            @click="anularActa">
            <i class="far fa-file-excel"></i> {{ $t('anular_acta') }}
          </b-button>
          <b-button :disabled="!(isValidFolioInit && ingreso.isActaValid)"
            style="background-color: orangered; color:white;" @click="generarActa">
            <i class="fa fa-file-alt"></i> {{ $t('generar_acta') }}
          </b-button>
          <b-button v-if="!isEditMode" @click="$router.push('/ingresos/documentos/' + ingreso.id)">
            <i class="far fa-file-image"></i> {{ $t('ver_documentos') }}
          </b-button>

          <template v-if="rol === 'admin'">
            <b-button @click="isEditMode = !isEditMode" :variant="!isEditMode ? 'info' : 'danger'">
              {{ !isEditMode ? $t('editar') : $t('cancelar') }}
            </b-button>

            <b-button v-if="isEditMode" :disabled="!isEditMode" type="submit" variant="primary" class="ml-2">
              {{ $t('actualizar') }}
            </b-button>
          </template>
        </div>
        <b-row v-if="rol === 'admin'">
          <b-col md="12">
            <b-row>
              <!--b-col md="2">
                <b-form-group :label="$t('tipo')">
                  <b-form-radio-group :disabled="!isEditMode" v-model="ingreso.tipo" name="tipo">
                    <b-form-radio value="O">{{ $t('origen') }}</b-form-radio>
                    <b-form-radio value="D">{{ $t('destino') }}</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-col-->

              <b-col md="2">
                <b-form-group label-for="paisID">
                  <template v-slot:label>
                    {{ $t('pais') }} <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-select id="paisID" :disabled="!isEditMode" @change="onChangePais" v-model="ingreso.paisID"
                    >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in paisOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label-for="fecha">
                  <template v-slot:label>
                    {{ $t('fecha') }} <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-input id="fecha" type="date" :disabled="!isEditMode" v-model="ingreso.fecha"
                    ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label-for="acta">
                  <template v-slot:label>
                    {{ $t('numero_acta') }}
                  </template>
                  <b-form-input id="acta" type="text" :disabled="true" v-model="ingreso.numeroActa"
                    :placeholder="$t('numero_acta')"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="6">
            <b-row class="mb-2">
              <strong>1. {{ $t('origen') }}</strong>
            </b-row>

            <b-row>
              <b-col md="4">
                <b-form-group label-for="empresaID">
                  <template v-slot:label>
                    {{ $t('empresa') }} <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-select id="empresaID" :disabled="!isEditMode" v-model="ingreso.empresaID"
                    @change="onEmpresaOrigenChange" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in empresaOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Origen" label-for="plantaOrigenID">
                  <template v-slot:label>
                    {{ $t('planta') + ' ' + $t('origen') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="plantaOrigenID" :disabled="!isEmpresaSelected || !isEditMode"
                    v-model="ingreso.plantaOrigenID" @change="onPlantaOrigenChange" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in plantaOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="Origen" label-for="pasilloOrigenID">
                  <template v-slot:label>
                    {{ $t('pasillo') + ' ' + $t('origen') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="pasilloOrigenID" :disabled="!isPlantaSelected || !isEditMode"
                    v-model="ingreso.pasilloOrigenID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in pasilloOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="6">
            <b-row class="mb-2">
              <strong>2. {{ $t('transporte_origen') }}</strong>
            </b-row>

            <b-row>
              <b-col md="4">
                <b-form-group label-for="choferID">
                  <template v-slot:label>
                    {{ $t('chofer') }} <span class="text-danger">*</span>
                  </template>

                  <el-select class="custom-input" :disabled="!isEditMode" v-model="ingreso.choferID" filterable
                    :placeholder="$t('seleccione_opcion')" style="width: 100%;">
                    <el-option v-for="item in choferOptions" :key="item.value" :label="item.text" :value="item.value" />
                  </el-select>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label-for="patente">
                  <template v-slot:label>
                    {{ $t('patente_camion') }} <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-input id="patente" :disabled="!isEditMode" v-model="ingreso.patente"  maxlength="7"
                    :placeholder="$t('ingrese_patente')"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label-for="patente">
                  <template v-slot:label>
                    {{ $t('patente_carro') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="patente" :disabled="!isEditMode" v-model="ingreso.patenteCarro"  maxlength="7"
                    placeholder="Ingrese la patente"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="12">
            <b-row class="mb-2">
              <strong>3. {{ $t('destino') }}</strong>
            </b-row>
            <b-row>
              <b-col class="col-md-2">
                <b-form-group label="Empresa Destino" label-for="empresaDestinoID">
                  <template v-slot:label>
                    {{ $t('empresa') + ' ' + $t('destino') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="empresaDestinoID" :disabled="!isEditMode" v-model="ingreso.empresaDestinoID"
                    @change="onEmpresaDestinoChange" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in empresaOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col class="col-md-2">
                <b-form-group label="Destino" label-for="plantaDestintoID">
                  <template v-slot:label>
                    {{ $t('planta') + ' ' + $t('destino') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="plantaDestintoID" :disabled="!isEmpresaDestinoSelected || !isEditMode"
                    v-model="ingreso.plantaDestinoID" @change="onPlantaDestinoChange" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in plantaDestinoOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col class="col-md-2">
                <b-form-group label="Destino" label-for="pasilloDestintoID">
                  <template v-slot:label>
                    {{ $t('pasillo') + ' ' + $t('destino') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-select id="pasilloDestintoID" :disabled="!isPlantaDestinoSelected || !isEditMode"
                    v-model="ingreso.pasilloDestinoID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }} </option>
                    <option v-for="option in pasilloDestinoOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="7">
            <b-row class="mb-2">
              <strong>4. {{ $t('guia_despacho') }}</strong>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label-for="folio">
                  <template v-slot:label>
                    {{ $t('numero_folio') }}
                  </template>
                  <b-form-input id="folio" @change="validaFolio" type="number" :disabled="!isEditMode"
                    v-model="ingreso.numeroFolio" min="0" :placeholder="$t('numero_folio')"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md-4>
                <b-form-group label-for="nro_hoja">
                  <template v-slot:label>
                    {{ $t('numero_hoja') }}
                  </template>
                  <b-form-input id="nro_hoja" @change="validaFolio" type="number" :disabled="!isEditMode"
                    v-model="ingreso.numeroHoja" min="0" :placeholder="$t('numero_hoja')"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col md-4>
                <b-form-group label-for="guiaTraslado">
                  <template v-slot:label>
                    {{ $t('guia_traslado') }} <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-input id="guiaTraslado" :disabled="!isEditMode" v-model="ingreso.guiaTraslado" 
                    :placeholder="$t('guia_traslado')"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label-for="montoGuiaTraslado">
                  <template v-slot:label>
                    {{ $t('monto_guia_traslado') }}
                    <span v-if="monedaOptions.find(t => t.value === ingreso.monedaID)">
                      ({{monedaOptions.find(t => t.value === ingreso.monedaID).text}})
                    </span>
                    <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  
                  <b-form-input id="montoGuiaTraslado" :disabled="!isEditMode"
                    type="text"
                    :value="$utilsService.getFormattedDecimal('montoGuiaTraslado', ingreso)"
                    @input="$utilsService.onInputDecimal('montoGuiaTraslado', ingreso, $event)"
                    @keypress="onlyNumbers"
                    :placeholder="$t('monto_guia')">
                  </b-form-input>

                  
                  
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label-for="ticket">
                  <template v-slot:label>
                    {{ $t('ticket') }}
                  </template>
                  <b-form-input id="ticket" :disabled="!isEditMode" v-model="ingreso.ticket"
                    :placeholder="$t('numero_ticket')"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label-for="ticketInex">
                  <template v-slot:label>
                    {{ $t('ticket_inex') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="ticketInex" :disabled="!isEditMode" v-model="ingreso.ticketInex" 
                    :placeholder="$t('numero_ticket_inexlink')"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label-for="peso">
                  <template v-slot:label>
                    {{ $t('peso_neto') }}
                    <span v-if="uomOptions.find(t => t.value === ingreso.uomID)">
                      ({{uomOptions.find(t => t.value === ingreso.uomID).text}})
                    </span>
                    <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-input id="peso" :disabled="!isEditMode"
                    :value="$utilsService.getFormattedDecimal('peso', ingreso)"  @keypress="onlyNumbers"
                    @input="$utilsService.onInputDecimal('peso', ingreso, $event)"  type="text" step="any"
                    :placeholder="$t('peso_neto')"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label-for="pesoInex">
                  <template v-slot:label>
                    {{ $t('peso_neto_inexlink') }}
                    <span v-if="uomOptions.find(t => t.value === ingreso.uomID)">
                      ({{uomOptions.find(t => t.value === ingreso.uomID).text}})
                    </span>
                    <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-input id="pesoInex" :disabled="!isEditMode"
                    :value="$utilsService.getFormattedDecimal('pesoInex', ingreso)" @keypress="onlyNumbers"
                    @input="$utilsService.onInputDecimal('pesoInex', ingreso, $event)"  type="text" step="any"
                    :placeholder="$t('peso_neto_inexlink')"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label-for="pesoTotal">
                  <template v-slot:label>
                    {{ $t('peso_total') }}
                    <span v-if="uomOptions.find(t => t.value === ingreso.uomID)">
                      ({{uomOptions.find(t => t.value === ingreso.uomID).text}})
                    </span>
                    <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-input id="pesoTotal" :disabled="!isEditMode"
                    :value="$utilsService.getFormattedDecimal('pesoTotal', ingreso)" @keypress="onlyNumbers"
                    @input="$utilsService.onInputDecimal('pesoTotal', ingreso, $event)" 
                    :placeholder="$t('peso_total')">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label-for="noConformidad">
                  <template v-slot:label>
                    {{ $t('no_conformidad') }}
                  </template>
                  <b-form-select id="noConformidad" :disabled="!isEditMode" v-model="ingreso.noConformidadID">
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in conformidadOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form-group label-for="comentarios">
                  <template v-slot:label>
                    {{ $t('comentarios_no_conformidad') }}
                  </template>
                  <b-form-textarea id="comentarios" :disabled="!isEditMode" v-model="ingreso.comentarios"
                    :placeholder="$t('comentarios_no_conformidad')"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>


          </b-col>

          <b-col md="5">
            <b-row class="mb-2">
              <strong>5. {{ $t('materiales') }}</strong>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label-for="materialID">
                  <template v-slot:label>
                    {{ $t('material_recibido') }} <span v-if="isEditMode" style="color: red;"
                      class="text-danger">*</span>
                  </template>
                  <b-form-select id="materialID" :disabled="!isEditMode" v-model="ingreso.materialID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in materialOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label-for="uomID">
                  <template v-slot:label>
                    {{ $t('uom') }} <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-select id="uomID" :disabled="!isEditMode" v-model="ingreso.uomID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in uomOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

          </b-col>

          <b-col md="8">
            <b-row class="mb-2">
              <strong>6. {{ $t('valor') }}</strong>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label="Precio" label-for="precio">
                  <template v-slot:label>
                    {{ $t('precio') }}
                    <span v-if="monedaOptions.find(t => t.value === ingreso.monedaID)">
                      ({{monedaOptions.find(t => t.value === ingreso.monedaID).text}})
                    </span>
                    <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="precio" :value="$utilsService.getFormattedDecimal('precio', ingreso)" @keypress="onlyNumbers"
                    @input="$utilsService.onInputDecimal('precio', ingreso, $event)" type="text" step="any" 
                    :disabled="!isEditMode" :placeholder="$t('precio')">
                  </b-form-input>
                 </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label-for="monedaID">
                  <template v-slot:label>
                    {{ $t('moneda') }} <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-select id="monedaID" :disabled="!isEditMode" v-model="ingreso.monedaID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in monedaOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label-for="porcentaje">
                  <template v-slot:label>
                    {{ $t('porcentaje_producto') }} <span class="text-danger">*</span>
                  </template>
                  <b-form-input id="porcentaje" :disabled="!isEditMode" v-model="ingreso.porcentajeProducto"  type="number"
                    step="1" 
                    min="0" 
                    max="100"
                    placeholder="Ingrese el porcentaje"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label-for="descuento">
                  <template v-slot:label>
                    {{ $t('descuento') }}
                  </template>
                  <b-form-input id="descuento" :disabled="!isEditMode" v-model="ingreso.descuento"  type="number" step="any"
                     :placeholder="$t('descuento')"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label-for="comentariosDescuento">
                  <template v-slot:label>
                    {{ $t('comentarios_descuento') }}
                  </template>
                  <b-form-textarea id="comentariosDescuento" :disabled="!isEditMode"
                    v-model="ingreso.comentariosDescuento" :placeholder="$t('comentarios_descuento')"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md-4>
                <b-form-group label-for="estadoPagoID">
                  <template v-slot:label>
                    {{ $t('estado_pago') }}
                  </template>
                  <b-form-select id="estadoPagoID" :disabled="!isEditMode" v-model="ingreso.estadoPagoID">
                    <option :value="null">{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in estadoPagoOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md-4>
                <b-form-group label-for="estadoID">
                  <template v-slot:label>
                    {{ $t('estado') }} <span v-if="isEditMode" class="text-danger">*</span>
                  </template>
                  <b-form-select id="estadoID" :disabled="!isEditMode" v-model="ingreso.estadoID" >
                    <option :value="null" disabled>{{ $t('seleccione_opcion') }}</option>
                    <option v-for="option in estadoIngresoOptions" :key="option.value" :value="option.value">
                      {{ option.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <!--/b-row-->
      </b-form>
    </base-header>
  </div>
</template>

<script>
import ingresoService from '@/api/ingresoService';
import utilsService from '@/api/utilsService';
import Loading from '@/components/Loading.vue';
import miscService from '@/api/miscService';
import actaService from '@/api/actaService';
import folioService from '@/api/folioService';
import Swal from 'sweetalert2';
import { Select, Option } from 'element-ui'
import empresaService from '@/api/empresaService.vue';

export default {
  components: {
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  data() {
    return {
      isEditMode: false,
      ingreso: {},
      materialOptions: [],
      conformidadOptions: [],
      empresaOptions: [],
      choferOptions: [],
      estadoIngresoOptions: [],
      estadoPagoOptions: [],
      uomOptions: [],
      monedaOptions: [],
      paisOptions: [],
      plantaOptions: [],
      plantaDestinoOptions: [],
      pasilloOptions: [],
      pasilloDestinoOptions: [],
      isEmpresaSelected: false,
      isEmpresaDestinoSelected: false,
      isPlantaSelected: false,
      isPlantaDestinoSelected: false,
      loading: true,
      isValidActa: false,
      isValidFolioInit: false
    };
  },
  computed: {
    rol() {
      return utilsService.getRol();
    }
  },
  async beforeMount() {
    await this.initData();
  },
  methods: {
    async initData() {
      const id = this.$route.params.id;

      const promises = [
        miscService.getEstadoPagosOptions(),
        miscService.getEstadosOptions(),
        miscService.getChoferesOptions(),
        miscService.getMaterialesOptions(),
        miscService.getConformidadesOptions(),
        miscService.getMonedasOptions(),
        miscService.getUomsOptions(),
        miscService.getPaisesOptions()
      ];
      const [
        estadoPagoOptions,
        estadoIngresoOptions,
        choferOptions,
        materialOptions,
        conformidadOptions,
        monedaOptions,
        uomOptions,
        paisOptions
      ] = await Promise.all(promises);

      this.ingreso = await ingresoService.get(id);
      this.estadoPagoOptions = estadoPagoOptions;
      this.estadoIngresoOptions = estadoIngresoOptions;
      this.choferOptions = choferOptions;
      this.materialOptions = materialOptions;
      this.conformidadOptions = conformidadOptions;
      this.monedaOptions = monedaOptions;
      this.uomOptions = uomOptions;
      this.paisOptions = paisOptions;
      this.isValidFolioInit = this.ingreso.numeroFolio > 0;
      if (this.rol === "admin" && this.ingreso) {
        this.empresaOptions = await miscService.getEmpresasOptions();
        if (this.ingreso.empresaID > 0)
          this.plantaOptions = await miscService.getPlantasByEmpresaOptions(this.ingreso.empresaID);
        if (this.ingreso.empresaDestinoID > 0)
          this.plantaDestinoOptions = await miscService.getPlantasByEmpresaOptions(this.ingreso.empresaDestinoID);

        if (this.ingreso.plantaOrigenID > 0 && this.ingreso.empresaID > 0)
          this.pasilloOptions = await miscService.getPasillosByEmpresaOptions(this.ingreso.empresaID, this.ingreso.plantaOrigenID);

        if (this.ingreso.plantaDestinoID > 0 && this.ingreso.empresaDestinoID > 0)
          this.pasilloDestinoOptions = await miscService.getPasillosByEmpresaOptions(this.ingreso.empresaDestinoID, this.ingreso.plantaDestinoID);

        this.isPlantaSelected = this.ingreso.plantaOrigenID > 0;
        this.isPlantaSelected = this.ingreso.plantaDestinoID > 0;
        this.isEmpresaSelected = this.ingreso.empresaID > 0;;
        this.isEmpresaDestinoSelected = this.ingreso.empresaDestinoID > 0;
      }
      this.isValidActa = this.ingreso.numeroFolio > 0;
      this.loading = false;

    },
    async onEmpresaOrigenChange() {
      const empresa = this.ingreso.empresaID;
      this.ingreso.pasilloOrigenID = null;
      this.ingreso.plantaOrigenID = null;
      if (empresa) {
        this.plantaOptions = await miscService.getPlantasByEmpresaOptions(empresa);
        this.isEmpresaSelected = true;
      } else {
        this.plantaOptions = [];
        this.isEmpresaSelected = false;
      }
    },
    async onEmpresaDestinoChange() {
      const empresa = this.ingreso.empresaDestinoID;
      this.ingreso.pasilloDestinoID = null;
      this.ingreso.plantaDestinoID = null;
      if (empresa) {
        this.plantaDestinoOptions = await miscService.getPlantasByEmpresaOptions(empresa);
        this.isEmpresaDestinoSelected = true;
      } else {
        this.plantaOptions = [];
        this.isEmpresaDestinoSelected = false;
      }
    },
    async onChangePais() {

      this.ingreso.pasilloDestinoID = null;
      this.ingreso.plantaDestinoID = null;
      this.ingreso.pasilloOrigenID = null;
      this.ingreso.plantaOrigenID = null;
      this.ingreso.empresaID = null;
      this.ingreso.empresaDestinoID = null;
      this.isEmpresaDestinoSelected = false;
      this.isPlantaSelected = false;
      this.isPlantaDestinoSelected = false;
      this.isEmpresaSelected = false;
      this.empresaOptions = await miscService.getEmpresasByPaisOptions(this.ingreso.paisID);
    },
    async onPlantaOrigenChange() {
      const empresa = this.ingreso.empresaID;
      const planta = this.ingreso.plantaOrigenID;
      if (empresa && planta) {
        this.pasilloOptions = await miscService.getPasillosByEmpresaOptions(empresa, planta);
        this.isPlantaSelected = true;
      } else {
        this.pasilloOptions = [];
        this.isPlantaSelected = false;
      }
    },
    async validaFolio() {

      const empresa = this.ingreso.empresaDestinoID;
      // Obtener frag Folio propio de la empresa
      const empresaData = await empresaService.get(empresa);
      //console.log('Empresa data:', empresaData);
      if (empresaData.swFolioPropio) {
        this.isValidActa = true;
        return;
      }

      // ...validación original...
      Swal.fire({
        html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                  <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                    <div>
                        <h3 style="color: #006393;">Validando Folio </h3>
                    </div>
                </div>`,
        showConfirmButton: false,
        allowOutsideClick: false
      });

      try {
        this.isValidActa = await folioService.getValidaFolio(this.ingreso.numeroFolio);
        if (!this.isValidActa) throw Error(false);

        this.$toast('Folio correcto.', {
          position: 'top-center',
          timeout: 2000,
          closeOnClick: true,
          pauseOnHover: true
        });

      }
      catch {
        if (this.ingreso.numeroFolio > 0 && !this.isValidActa) {
          this.$toast.error('Folio ingresado no existe.', {
            position: 'top-center',
            timeout: 2000,
            closeOnClick: true,
            pauseOnHover: true
          });
        }
      }

      Swal.close();
    },
    async anularActa() {
      Swal.fire({
        title: this.$t('estas_seguro'),
        text: this.$t('anular_acta_msj'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('anular'),
        cancelButtonText: this.$t('cancelar')
      }).then(async (result) => {
        if (result.isConfirmed) {

          Swal.fire({
            html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">Anulando Acta...</h3>
                        </div>
                    </div>`,
            showConfirmButton: false,
            allowOutsideClick: false
          });

          try {

            const resp = await actaService.anularActa(this.ingreso.id);
            Swal.close();
            this.ingreso = await ingresoService.get(this.ingreso.id);

            this.$toast('Acta anulada correctamente.', {
              position: 'top-center',
              type: 'success',
              timeout: 2000,
              closeOnClick: true,
              pauseOnHover: true
            });

          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.message
            });
          }
        }
      });
    },

    async generarActa() {

      if (this.ingreso.pesoTotal <= 0) {

        this.$toast.error('Peso Total no puede ser 0.', {
          position: 'top-center',
          timeout: 2000,
          closeOnClick: true,
          pauseOnHover: true
        });
        return;
      }


      Swal.fire({
        html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">Generando Acta...</h3>
                        </div>
                    </div>`,
        showConfirmButton: false,
        allowOutsideClick: false
      });

      try {

        const resp = await actaService.getActa(this.ingreso.id);
        Swal.close();
        this.ingreso = await ingresoService.get(this.ingreso.id);

      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message
        });

      }

    },
    async onPlantaDestinoChange() {
      const empresa = this.ingreso.empresaDestinoID;
      const planta = this.ingreso.plantaDestinoID;
      if (empresa && planta) {
        this.pasilloDestinoOptions = await miscService.getPasillosByEmpresaOptions(empresa, planta);
        this.isPlantaDestinoSelected = true;
      } else {
        this.pasilloDestinoOptions = [];
        this.isPlantaDestinoSelected = false;
      }
    },
    validateRequiredFields() {
      const requiredFields = [
        { field: 'paisID', name: 'País' },
        { field: 'fecha', name: 'Fecha' },
        { field: 'empresaID', name: 'Empresa Origen' },
        { field: 'plantaOrigenID', name: 'Planta Origen' },
        { field: 'pasilloOrigenID', name: 'Pasillo Origen' },
        { field: 'choferID', name: 'Chofer' },
        { field: 'patente', name: 'Patente Camión' },
        { field: 'patenteCarro', name: 'Patente Carro' },
        { field: 'empresaDestinoID', name: 'Empresa Destino' },
        { field: 'plantaDestinoID', name: 'Planta Destino' },
        { field: 'pasilloDestinoID', name: 'Pasillo Destino' },
        { field: 'guiaTraslado', name: 'Guía de Traslado' },
        { field: 'montoGuiaTraslado', name: 'Monto Guía Traslado' },
        { field: 'ticketInex', name: 'Ticket Inexlink' },
        { field: 'peso', name: 'Peso Neto' },
        { field: 'pesoInex', name: 'Peso Neto Inexlink' },
        { field: 'pesoTotal', name: 'Peso Total' },
        { field: 'materialID', name: 'Material Recibido' },
        { field: 'uomID', name: 'UOM' },
        { field: 'precio', name: 'Precio' },
        { field: 'monedaID', name: 'Moneda' },
        { field: 'porcentajeProducto', name: 'Porcentaje Producto' },
        { field: 'estadoID', name: 'Estado' }
      ];

      const missingFields = [];

      requiredFields.forEach(({ field, name }) => {
        const value = this.ingreso[field];
        if (value === null || value === undefined || value === '' || value === 0) {
          missingFields.push(name);
        }
      });

      return missingFields;
    },

    async submitForm() {
      // Validar campos requeridos solo si estamos en modo edición
      if (this.isEditMode) {
        const missingFields = this.validateRequiredFields();
        
        if (missingFields.length > 0) {
          const fieldsList = missingFields.join(', ');
          Swal.fire({
            icon: "warning",
            title: "Campos requeridos",
            html: `Los siguientes campos son requeridos:<br><strong>${fieldsList}</strong>`,
            confirmButtonText: "Entendido"
          });
          return;
        }
      }

      Swal.fire({
        title: this.$t('guardar'),
        text: this.$t('estas_seguro_guardar'),
        icon: 'info',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t('aceptar'),
        denyButtonText: this.$t('cancelar'),
      }).then(async (result) => {
        if (result.isConfirmed) {

          if (!this.isValidActa && this.ingreso.numeroFolio > 0) {
            this.$toast.error('Folio ingresado no existe.', {
              position: 'top-center',
              timeout: 2000,
              closeOnClick: true,
              pauseOnHover: true
            });
            return;
          }
          try {
            Swal.fire({
              html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('guardando')}</h3>
                        </div>
                    </div>`,
              showConfirmButton: false,
              allowOutsideClick: false
            });
            
            if (this.ingreso.empresaID == this.ingreso.empresaDestinoID) {
              this.$toast.error('La Empresa de origen no puede ser igual a la de Destino.', {
                position: 'top-center',
                timeout: 2000,
                closeOnClick: true,
                pauseOnHover: true
              });
              Swal.close();
              return;
            }

            if (this.ingreso.pasilloDestinoID == this.ingreso.pasilloOrigenID) {
              this.$toast.error('El Pasillo de origen no puede ser igual al de Destino.', {
                position: 'top-center',
                timeout: 2000,
                closeOnClick: true,
                pauseOnHover: true
              });
              Swal.close();
              return;
            }
            
            await ingresoService.update(this.ingreso, this.ingreso.id);

            this.ingreso = await ingresoService.get(this.ingreso.id);
            this.isValidFolioInit = this.ingreso.numeroFolio > 0;
            this.isEditMode = false;
            
            Swal.fire({
              title: this.$t('cambios_guardados'),
              icon: "success",
              showConfirmButton: false,
              timer: 2000,
              background: '#f8f9fa',
              customClass: {
                title: 'swal-title',
                icon: 'swal-icon',
              },
            });

          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.message
            });
          }
        } else if (result.isDenied) {
          Swal.close();
        }
      });
    },
        onlyNumbers(event) {
      const ctrl = ['Backspace','Delete','Tab','Enter','ArrowLeft','ArrowRight','Home','End'];
      if (ctrl.includes(event.key)) return;

      // Solo dígitos y coma (el punto lo agregamos nosotros como miles)
      if (!/[0-9,]/.test(event.key)) {
        event.preventDefault();
        return;
      }

      const v = event.target.value || '';
      if (event.key === ',' && v.includes(',')) {
        // una sola coma decimal
        event.preventDefault();
      }
}
  },
};
</script>
<style>
.el-table.table-dark {
  background-color: #4d4c4c;
  color: #f8f9fe;
}

.el-table.table-dark th,
.el-table.table-dark tr {
  background-color: #4d4c4c;
}

.el-table.table-dark td,
.el-table.table-dark th.is-leaf {
  border-bottom: none;
}
</style>
